import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ProfitLossUI from './ProfitLossUI';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import DailyReportsServices from '../../../services/axiosServices/apiServices/DailyReportsServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { CommonValidationMessages } from '../../../utils/Messages';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import { getFinancialYearDates } from '../../../utils/DateUtils';

export default class ProfitLossReport extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            idCompany: 0,
            idUser: 0,
            profitObject: {
                search: "",
                fromDate: "",
                toDate: "",
                includeZero: false,
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "fromDate"
                        ),
                    },
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "toDate"
                        ),
                    },
                ],
            },
            profitLossData: {
                expenses: [
                    // {
                    //     title: "Purchase Accounts",
                    //     total: 172828.30,
                    //     items: [
                    //         { name: "Raw Material Purchase", amount: 98750.00 },
                    //         { name: "Packing Material", amount: 32000.00 },
                    //         { name: "Transport Charges", amount: 42078.30 },
                    //     ],
                    // },
                    // {
                    //     title: "Indirect Expenses",
                    //     total: 365.42,
                    //     items: [
                    //         { name: "Bank Charge", amount: 68.42 },
                    //         { name: "R/OFF", amount: 6.72 },
                    //         { name: "Internet Exp.", amount: 290.28 },
                    //     ],
                    // },
                    // {
                    //     title: "Administrative Expenses",
                    //     total: 432559.96,
                    //     items: [
                    //         { name: "Office Rent", amount: 160000.00 },
                    //         { name: "Light Bill", amount: 178600.00 },
                    //         { name: "Internet Exp.", amount: 5306.46 },
                    //         { name: "Software Purchase @ 18%", amount: 15177.96 },
                    //         { name: "Standard SSL Certificate", amount: 9897.00 },
                    //         { name: "Spare Parts @ 18%", amount: 63080.00 },
                    //     ],
                    // },
                ],
                income: [
                    // {
                    //     title: "Sales Accounts",
                    //     total: 222831.00,
                    //     items: [
                    //         { name: "Local Sales", amount: 145000.00 },
                    //         { name: "Online Sales", amount: 77831.00 },
                    //     ],
                    // },
                    // {
                    //     title: "Direct Income",
                    //     total: 199799.00,
                    //     items: [
                    //         { name: "Net Sales", amount: 199799.00 },
                    //     ],
                    // },
                    // {
                    //     title: "Other Income",
                    //     total: 75856.86,
                    //     items: [
                    //         { name: "Interest Received", amount: 12856.86 },
                    //         { name: "Commission Income", amount: 63000.00 },
                    //     ],
                    // },
                ],
                totalAssets: 0,
                totalLiabilities: 0,
            }
        }
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                let requestDetails = localStorage.getItem("balanceSheetReportDetails");
                if (requestDetails) {
                    requestDetails = JSON.parse(requestDetails);
                    requestDetails.fromDate = requestDetails.fromDate ? moment(requestDetails.fromDate).format('YYYY-MM-DD') : "";
                    requestDetails.toDate = requestDetails.toDate ? moment(requestDetails.toDate).format('YYYY-MM-DD') : "";

                    let details = this.state.profitObject
                    details.fromDate = requestDetails.fromDate ? moment(requestDetails.fromDate).format('YYYY-MM-DD') : "";
                    details.toDate = requestDetails.toDate ? moment(requestDetails.toDate).format('YYYY-MM-DD') : "";
                    this.setState({ profitObject: details }, () => {
                        this.getProfitLossReport()
                    })
                } else {
                    let details = this.state.profitObject
                    details.fromDate = getFinancialYearDates().fromDate;
                    details.toDate = getFinancialYearDates().toDate;
                    this.setState({ profitObject: details })
                }
            });
        }
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.profitObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.profitObject;
        if (name === 'includeZero') {
            let checked = event.target.checked
            details.includeZero = checked
        } else {
            details[name] = value;
        }
        this.setState({ profitObject: details }, () => {
            if (name === 'includeZero') {
                this.getProfitLossReport()
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    // getProfitLossReport = () => {
    //     let isValid = this.isValidAllFields()
    //     if (isValid) {
    //         let request = {
    //             fromDate: this.state.profitObject.fromDate,
    //             toDate: this.state.profitObject.toDate,
    //             idCompany: this.state.idCompany
    //         };
    //         this.dailyReportsServices.getProfitLossReport(request).then((response) => {
    //             if (response.statusCode === 200 && response.responseItem !== null) {
    //                 let result = response.responseItem.responseContent
    //                 const allHeads = result[1]
    //                     .filter(h => this.state.profitObject.includeZero ? true : h.headTotal !== 0)
    //                     .map(h => ({
    //                         ...h,
    //                         name: h.accountHead,
    //                         amount: h.headTotal || 0,
    //                         sub: result[2]
    //                             .filter(p => p.idAccountHead === h.idAccountHead)
    //                             .filter(p => this.state.profitObject.includeZero ? true : p.productAmount !== 0)
    //                             .map(p => ({
    //                                 name: p.productName,
    //                                 amount: p.productAmount || 0,
    //                                 idGeneralProduct: p.idGeneralProduct
    //                             }))
    //                     }));

    //                 const expense = allHeads.filter(g => g.accountHeadDesc === 'E');
    //                 const income = allHeads.filter(g => g.accountHeadDesc === 'I');
    //                 let profitLossData = this.state.profitLossData
    //                 profitLossData.expenses = expense
    //                 profitLossData.income = income
    //                 profitLossData.totalAssets = expense.reduce((sum, g) => sum + (g.amount || 0), 0)
    //                 profitLossData.totalLiabilities = income.reduce((sum, g) => sum + (g.amount || 0), 0)
    //                 this.setState({ profitLossData: profitLossData })
    //             }
    //         });
    //     }
    // }

    getProfitLossReport = () => {
        let isValid = this.isValidAllFields()

        if (isValid) {
            let request = {
                fromDate: this.state.profitObject.fromDate,
                toDate: this.state.profitObject.toDate,
                idCompany: this.state.idCompany
            };

            this.dailyReportsServices.getProfitLossReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {

                    let result = response.responseItem.responseContent;

                    const allHeads = result[1]
                        .filter(h => {
                            const displayVal = h.headTotal;
                            return this.state.profitObject.includeZero ? true : displayVal !== 0;
                        })
                        .map(h => {
                            const sub = result[2]
                                .filter(p => p.idAccountHead === h.idAccountHead)
                                .filter(p => {
                                    const displayVal = p.productAmount;
                                    return this.state.profitObject.includeZero ? true : displayVal !== 0;
                                })
                                .map(p => ({
                                    name: p.productName,
                                    amount: p.productAmount,
                                    idGeneralProduct: p.idGeneralProduct
                                }));

                            // Head total = plain sum of its sub-item amounts (no contra subtraction).
                            // Sub-items are displayed as absolute values, so sum the same way.
                            const headAmount = sub.reduce((s, p) => s + (Math.abs(Number(p.amount)) || 0), 0);

                            return {
                                ...h,
                                name: h.accountHead,
                                amount: headAmount,
                                sub
                            };
                        });

                    const expense = allHeads.filter(g => g.accountHeadDesc === 'E');
                    const income = allHeads.filter(g => g.accountHeadDesc === 'I');

                    let profitLossData = this.state.profitLossData;

                    profitLossData.expenses = expense;
                    profitLossData.income = income;

                    profitLossData.totalAssets = expense.reduce((sum, g) => sum + (Math.abs(g.amount) || 0), 0);
                    profitLossData.totalLiabilities = income.reduce((sum, g) => sum + (Math.abs(g.amount) || 0), 0);

                    this.setState({ profitLossData });
                }
            });
        }
    }

    redirectToLedger = (data) => {
        let requestDetails = {
            fromDate: this.state.profitObject.fromDate,
            toDate: this.state.profitObject.toDate,
            partyId: data.idGeneralProduct,
            exponseById: 4
        }
        localStorage.setItem("accountHeadSummary", JSON.stringify(requestDetails));
        this.setState({ route: '/account-head-summary' });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='profit-loss-report'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ProfitLossUI
                            profitObject={this.state.profitObject}
                            validState={this.state.validState}
                            handleChange={this.handleChange.bind(this)}
                            profitLossData={this.state.profitLossData}
                            getProfitLossReport={this.getProfitLossReport.bind(this)}
                            redirectToLedger={this.redirectToLedger.bind(this)}
                        />
                    </div>
                </div>
            </div>
        )
    }
}